import React from 'react';
import {
  ResponsiveContentTab,
  ResponsivePosterTab,
  ResponsiveProductTab,
} from 'src/constrains/DraggableModules/Components';
import { AdaSelect } from 'src/constrains/DraggableModules/Components/AdaptorSelection';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { EnumModuleType } from 'src/types/common/module';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import css from './css.module.less';

const ResponsiveTab = (props) => {
  const { staticData, onModuleTypeChange, draggableId, extraProps, ...rest } =
    props;
  //console.log('onModuleTypeChange', onModuleTypeChange);
  const { breakpoint } = extraProps || {};

  const { moduleType } = staticData;
  // console.log('moduleType', moduleType);
  const handleOnModuleTypeChange = (e) => {
    //console.log('type', e);
    const type = e;
    //console.log('type', type);
    const data = { moduleType: type, id: draggableId };
    //console.log('data1', data);
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };
  const isConvertible = breakpoint !== EPreviewSize.WIDE;

  const Dict = React.useMemo(() => {
    return {
      [EnumModuleType.ResponsivePosterTab]: ResponsivePosterTab,
      [EnumModuleType.ResponsiveProductTab]: ResponsiveProductTab,
      [EnumModuleType.ResponsiveContentTab]: ResponsiveContentTab,
      //ResponsiveContentTab
    };
  }, []);
  const generateModule = () => {
    const Module = Dict[moduleType];
    //  const _props = { ...rest, extraProps };

    return (
      <Module
        {...rest}
        extraProps={extraProps}
        draggableId={draggableId}
        staticData={staticData}
      />
    );
  };
  return (
    <div className={css.container}>
      {!isConvertible && (
        <AdaSelect
          title='Tab Type'
          value={moduleType}
          onChange={handleOnModuleTypeChange}
          list={[
            {
              value: EnumModuleType.ResponsivePosterTab,
              label: 'Poster',
            },
            {
              value: EnumModuleType.ResponsiveProductTab,
              label: 'Product Grid',
            },
            {
              value: EnumModuleType.ResponsiveContentTab,
              label: 'Content Page Grid',
            },
            // {
            //   value: EnumModuleType.ResponsiveContentGrid,
            //   label: 'Content Page',
            // },
          ]}
        />
      )}

      {/* <AdaSelection
        title='Carousel Type'
        list={[
          {
            value: EnumModuleType.Carousel,
            label: 'Image',
            className: css.radioItem,
          },
          {
            value: EnumModuleType.ProductCarousel,
            label: 'Product',
            className: css.radioItem,
          },
          {
            value: EnumModuleType.ArticleCarousel,
            label: 'Content Page',
          },
        ]}
        value={moduleType}
        onChange={handleOnModuleTypeChange}
      />{' '} */}
      {/* <Section bottomBorder>
        <ItemWrapper title='Carousel Type'>
          <Radio
            className={css.radioContainer}
            radioList={[
              {
                value: EnumModuleType.Carousel,
                label: 'Carousel',
                className: css.radioItem,
              },
              {
                value: EnumModuleType.ProductCarousel,
                label: 'Product Carousel',
              },
            ]}
            value={moduleType}
            onChange={handleOnModuleTypeChange}
          />
        </ItemWrapper>
      </Section> */}
      {generateModule()}
    </div>
  );
};
export default DataHOC(ResponsiveTab);
